module.exports = __webpack_public_path__ + "static/media/file-pdf.8e1491c8.svg";